import type {
  FindPendingShippingResponse,
  ShippingForRouting,
} from '../models/routing.types';
import { VisitType } from '../models/routing.types';

function parseCoord(value: string | number | undefined | null): number {
  if (value == null) return 0;
  if (typeof value === 'number' && !Number.isNaN(value)) return value;
  const n = Number(value);
  return Number.isNaN(n) ? 0 : n;
}

export function mapFindPendingToShippingForRouting(
  data: FindPendingShippingResponse,
  logisticOperatorId: string
): ShippingForRouting {
  const isDelivery = data.visitType === VisitType.DELIVERY;
  const dest = data.destinationAddress;
  const origin = data.originAddress;

  const lat =
    isDelivery && dest
      ? parseCoord(dest.lat)
      : origin
        ? parseCoord(origin.lat)
        : dest
          ? parseCoord(dest.lat)
          : 0;
  const long =
    isDelivery && dest
      ? parseCoord(dest.long)
      : origin
        ? parseCoord(origin.long)
        : dest
          ? parseCoord(dest.long)
          : 0;

  const addressForDelivery = dest
    ? {
        streetName: dest.streetName,
        doorNumber: dest.doorNumber,
        apartmentNumber: dest.apartmentNumber ?? null,
        lat,
        long,
      }
    : null;

  const addressForOrigin = origin
    ? {
        streetName: origin.streetName,
        doorNumber: origin.doorNumber,
        lat: parseCoord(origin.lat),
        long: parseCoord(origin.long),
      }
    : null;

  return {
    number: data.number,
    recipient: '',
    recipientPhoneNumber: '',
    commerceShippingNumber: data.externalId ?? '',
    destinationAddress: addressForDelivery,
    originAddress: addressForOrigin,
    commerce: null,
    commercialService: data.serviceType
      ? {
          id: '',
          name: data.serviceType,
          commercialName: data.serviceType,
        }
      : null,
    status: null,
    dateToDelivery: '',
    logisticOperatorId,
    visitType: data.visitType,
    serviceVisitTypeName: data.serviceVisitTypeName,
    serviceType: data.serviceType,
  };
}
